import { render, staticRenderFns } from "./Breaches.vue?vue&type=template&id=3e1827e3&scoped=true"
import script from "./Breaches.vue?vue&type=script&lang=js"
export * from "./Breaches.vue?vue&type=script&lang=js"
import style0 from "./Breaches.vue?vue&type=style&index=0&id=3e1827e3&prod&scoped=true&lang=scss"
import style1 from "./Breaches.vue?vue&type=style&index=1&id=3e1827e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1827e3",
  null
  
)

export default component.exports